<template>
<div class="page page_baocuo">
    <div class="filed">
        <div class="filed_title">报错内容</div>
        <div class="filed_nr">
            <van-field v-model="address" type="textarea" placeholder="请您输入报错内容...."  />
        </div>
    </div>
	<div class="filed">
        <div class="filed_title">正确内容</div>
        <div class="filed_nr">
            <van-field v-model="describe" type="textarea" placeholder="请您输入正确内容..."  />
        </div>
    </div>
	<div class="actions">
		<div class="bottom_action" @click="tijiaoFun">确认提交</div>
	</div>
</div>
</template>

<script>
import router from "../../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../../.././vuex/mutation_types";

import Vue from "vue";
import Bridge from "../../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    // name: "map-index",
    data() {
        return {
			shopid: this.$route.query.shopid,
			address: '', // 地址 比如错误信息在第几行
			describe: '', // 信息 比如更正的正确信息
			token: ''
        };
    },
    created: function () {
		if (userAgent && userAgent.indexOf('shidaijiyi') != -1) {
            var params = {
                'data': {
                    'naviTitle': '项目报错'
                }
            }
            this.$bridge.callhandler('sdjy://navigation/style', params, (data) => {

            })
            //获取用户信息
            var memberParams = {
                'data': {
                    'notCallLogin': 1,
                }
            }
            this.$bridge.callhandler('sdjy://member/memberInfo', memberParams, (data) => {
                if (data.code == 200) {
                    this.token = data.result.token
                } else {
                    this.token = ''
                }
            })
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler('sdjy://common/refreshPage', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                responseCallback(data)
            })
        } else {
            // 获取列表
            this.token = this.$store.getters.token
        }
    },
    methods: {
		// 提交
		tijiaoFun(){
			if(!this.address){
				this.$toast('报错内容不能为空');
				return
			}
			if(!this.describe){
				this.$toast('正确信息不能为空');
				return
			}
			var params = {
				token: this.token,
				shopid: this.shopid,
				address: this.address,
				describe: this.describe
			}
			console.log(params)
			this.$api.map.baocuo(params).then(res=>{
				if(res.code == 200){
					console.log(res)
					this.$toast('提交报错成功');
					this.$router.back(-1);
				}
			})
		}
    }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
